export interface versionInterface {
  version: string;
  description: string;
  date: number,
  showMore: boolean
}

export const appVersionHistory: versionInterface[] = [
  {
    "version": "1.0.1",
    "description": "Se añade en la interfaz de detalles de un contacto que se pueda visualizar el estado del Opt-in como un campo más editable. Se añade funcionalidad que permite que el reenviar un contenido de campaña por mala categorización. Se corrige bug en grafico de torta en informe de campaña SMS. Se mejora la visualización de de la tabla en el modulo de contactos. Se crea vista para ver cambios según versión de plataforma. Se mejora la visualización de la configuración de notificaciones desde el modulo de marketing. Se corrige bug de en dashboard de trobbit live. Se corrige bug en filtro de agentes en dashboard trobbit live.",
    "date": 1698274837000,
    "showMore": false
  }
]
